package anjuros.development.components

import androidx.compose.runtime.Composable
import anjuros.development.components.language.LocalText
import anjuros.development.modules.Review
import anjuros.development.modules.Theme
import anjuros.development.util.Constants
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun ReviewCard(modifier: Modifier, review: Review){
    Link(
        modifier = Modifier.cursor(Cursor.Pointer)
            .styleModifier {
                property("pointer-events","none")
            }.textDecorationLine(TextDecorationLine.None),
        path =""
    ) {
        Box(modifier = modifier) {
            Column(modifier = Modifier,
                verticalArrangement = Arrangement.Center){

                P(
                    attrs = Modifier
                        .fillMaxWidth()
                        .align(Alignment.CenterHorizontally)
                        .margin(topBottom = 0.px)
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontSize(18.px)
                        .color(Theme.Primary.rgb)
                        .fontWeight(FontWeight.Bold)

                        .toAttrs()
                ) {
                    Text(review.author)

                }
                P(
                    attrs = Modifier
                        .fillMaxWidth()
                        .margin(topBottom = 0.px)
                        .align(Alignment.CenterHorizontally)
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontSize(16.px)
                        .color(Theme.DarkGrey.rgb)
                        .fontWeight(FontWeight.Normal)

                        .toAttrs()
                ) {
                    Text(LocalText(review.source))

                }
                P(
                    attrs = Modifier
                        .fillMaxWidth()
                        .fontFamily(Constants.FONT_FAMILY)
                        .margin(topBottom = 20.px)
                        .fontSize(16.px)
                        .color(Theme.Secondary.rgb)
                        .fontWeight(FontWeight.Normal)
                        .fontStyle(FontStyle.Italic)

                        .toAttrs()
                ) {
                    Text("\"${LocalText(review.review)}\"")

                }

            }


        }
    }
}